import actions from '@/features/projectList/store/projectList.store.actions'
import getters from '@/features/projectList/store/projectList.store.getters'
import mutations from '@/features/projectList/store/projectList.store.mutations'

export interface IProjectItem {
  id: string,
  uuid: string,
  name: string,
  nameByCustomer: string,
  customerId: string,
  createdUTC: string,
  system: 'sconn'| 'sctrl'
}

export interface IProjectStore {
  projects: IProjects | undefined,
  search: string,
  select: string,
  selectedProjects: ISelectedProjects[],
  isDisable: boolean
}

export interface IProjects {
  items: IProjectItem[],
  count: number
}

export interface IProjectItemsGetterResult extends Array<IProjectItem> {
  $error?: boolean,
  $errorReason?: string
}

export interface ISelectedProjects {
  id: number,
  system: string
}

export interface ISelectSystem {
  label: string,
  value: string
}

export const state: IProjectStore = {
  projects: {
    items: [],
    count: 0
  },
  search: '',
  select: '',
  selectedProjects: [],
  isDisable: true
}

export default {
  state,
  actions,
  getters,
  mutations
}
